import auth from '@/routes/auth';
import dashboard from '@/routes/dashboard';
import home from '@/routes/home';
import books from '@/routes/books/index.js';
import games from '@/routes/games/index.js';
import legal from '@/routes/legal/index.js';
import quran from '@/routes/quran/index.js';
import academy from '@/routes/academy/index.js';

export default [...auth, ...home, ...dashboard, ...books, ...games, ...legal, ...quran, ...academy];
